import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=22cedf9f&"
import script from "./CreateEvent.vue?vue&type=script&lang=ts&"
export * from "./CreateEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports